import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class ShowResourceAnnotation extends AbstractAnnotations{

    static get VIDEO() {
        return "showResourceVideo"
    }

    static get AUDIO() {
        return "showResourceAudio"
    }

    static get IMAGE() {
        return "showResourceImage"
    }

    static get HTML() {
        return "showResourceHtml"
    }

    static get GLOSSARY() {
        return "showResourceGlossary"
    }

    static get OFFICEDOC() {
        return "showResourceOfficeDoc"
    }

    static get ZIP() {
        return "showResourceZip"
    }

    constructor(builder) {

        super();
        const { pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;
        this.annotations["isShowResourceBtn"] = true;

        for (let [key,value] of Object.entries(builder.meta)) {

            if (key === "icon") {
                super.setAnnotations({"iconSrc":value});
            }
            else if (key === "url") {
                super.setAnnotations({[key]:value});

                let extension = value.split(".").pop();
                let type;

                //TODO: clean codes using config...
                if (parseInt(builder.meta.isDictionary) === 1) {
                    type = "glossary"
                    if (!this.annotationTypes.includes(ShowResourceAnnotation.GLOSSARY)) {
                        this.annotationTypes.push(ShowResourceAnnotation.GLOSSARY);
                    }

                } else {

                     //regular expression to check if it's a valid url

                    let regexpUrl =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

                    //TODO: use config..clean codes...
                    if (extension === "mp4") {
                        type = "video"
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.VIDEO)) {
                            this.annotationTypes.push(ShowResourceAnnotation.VIDEO);
                        }
                    } else if (extension === "mp3") {
                        type = "audio";
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.AUDIO)) {
                            this.annotationTypes.push(ShowResourceAnnotation.AUDIO);
                        }
                    } else if (["jpg", "png", "gif"].includes(extension)) {
                        type = "image";
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.IMAGE)) {
                            this.annotationTypes.push(ShowResourceAnnotation.IMAGE);
                        }

                    //since url value can be relative, so check both regular expression and extension
                    } else if (regexpUrl.test(value)) {

                        type = "html-external";
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.HTML)) {
                            this.annotationTypes.push(ShowResourceAnnotation.HTML);
                        }
                    } else if (extension.substr(0,3) === "htm" || extension.substr(0,4) === "html" ) {

                        type = "html-internal";
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.HTML)) {
                            this.annotationTypes.push(ShowResourceAnnotation.HTML);
                        }
                    } else if (["doc", "docx", "ppt", "pptx", "xls", "xlsx", "pdf"].includes(extension)) {
                        type = "officedoc"
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.OFFICEDOC)) {
                            this.annotationTypes.push(ShowResourceAnnotation.OFFICEDOC);
                        }
                    } else if (extension === "zip") {
                        type = "zip";
                        if (!this.annotationTypes.includes(ShowResourceAnnotation.ZIP)) {
                            this.annotationTypes.push(ShowResourceAnnotation.ZIP);
                        }
                    }
                }

                super.setAnnotations({"type": type});

            }
            else if (key === "WindowWidth") {
                super.setAnnotations({"width":value});
            }

            else if (key === "WindowHeight") {
                super.setAnnotations({"height":value});
            }

            else if (key === "showmode") {
                super.setAnnotations({[key]:value});
            }
            else if (key === "targetRectId") {
                super.setAnnotations({[key]:value});
            }
            else if (key === "hide") {
                if (value === "1") {
                    super.setAnnotations({[key]: parseInt(value)});
                }
            }
            else if (key === "t") {
                super.setAnnotations({[key]: parseInt(value)});
            }
            else if (key === "u") {
                if (value === "1") {
                    super.setAnnotations({needAccessToken: parseInt(value)});
                }
            }
        }

    }

}

export default ShowResourceAnnotation